const GL_TYPES = new Set(['3', '8', '9']); // GL, GAPL, HPGL

const baseTabs = [
  { id: 'installation', name: 'Installation' },
  { id: 'runlife', name: 'Runlife' },
];

export function getCompletionTabsByLiftType(liftType: string) {
  if (liftType === '2') return completionESPTabs;
  if (GL_TYPES.has(liftType)) return completionGLTabs;
  return baseTabs;
}

export const completionESPTabs = [
  ...baseTabs,
  { id: 'completion', name: 'Completion' },
  { id: 'pumps', name: 'Pumps' },
  { id: 'fluid', name: 'Fluid' },
];

export const completionGLTabs = [
  ...baseTabs,
  { id: 'completion', name: 'Completion' },
  { id: 'bores', name: 'Bores' },
  { id: 'valves', name: 'Valves' },
];

export const datumElevationSelect = [
  {
    key: 0,
    value: 'RKB',
  },
  {
    key: 1,
    value: 'SS',
  },
  {
    key: 2,
    value: 'MSL',
  },
  {
    key: 3,
    value: 'WH',
  },
];

export const inflowModelSelect = [
  {
    key: 0,
    value: 'PI',
  },
  {
    key: 1,
    value: 'Vogel',
  },
  {
    key: 2,
    value: 'Composite',
  },
];

export const solutionGORCCorrelationSelect = [
  {
    key: 0,
    value: 'Lasater',
  },
  {
    key: 1,
    value: 'Standing',
  },
  {
    key: 2,
    value: 'VazquesBeggs',
  },
  {
    key: 3,
    value: 'Glaso',
  },
];

export const formationVolumeFactorCorrelation = [
  {
    key: 0,
    value: 'VazquesBeggs',
  },
  {
    key: 1,
    value: 'Standing',
  },
  {
    key: 2,
    value: 'Glaso',
  },
];

export const viscosityCorrelation = [
  {
    key: 0,
    value: 'BeggsRobinson',
  },
  {
    key: 1,
    value: 'Glaso',
  },
];

export const mPFCorrelations = [
  {
    key: 0,
    value: 'HagedornBrown',
  },
  {
    key: 1,
    value: 'ALP',
  },
  {
    key: 2,
    value: 'DunsRos',
  },
];

export const flowOpts = [
  {
    key: 0,
    value: 'TubularFlow',
  },
  {
    key: 1,
    value: 'AnnularFlow',
  },
];

export const valveTypes = [
  {
    key: 0,
    value: 'Bellows',
  },
  {
    key: 1,
    value: 'Orifice',
  },
  {
    key: 2,
    value: 'Dummy',
  },
];

export const injectionTypes = [
  {
    key: 0,
    value: 'Tubular',
  },
  {
    key: 1,
    value: 'Annular',
  },
];

export const valvesSizes = [
  {
    key: 1,
    value: '1',
  },
  {
    key: 1.5,
    value: '1-1/2',
  },
];
